import React from 'react';
import { theme as antTheme } from 'antd';

/**
 * Shared page chrome — colors from Ant Design theme schema (ConfigProvider).
 */
export default function PageShell({
  title,
  description,
  actions,
  children,
  style,
}) {
  const { token } = antTheme.useToken();

  return (
    <div
      style={{
        padding: '20px 8px 32px',
        minHeight: '100%',
        ...style,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: 16,
          flexWrap: 'wrap',
          marginBottom: 16,
        }}
      >
        <div>
          <h2
            style={{
              margin: 0,
              color: token.colorBrandPrimary || token.colorInfo,
              fontWeight: 700,
              fontSize: 22,
              fontFamily: token.fontFamily,
            }}
          >
            {title}
          </h2>
          {description ? (
            <p
              style={{
                margin: '6px 0 0',
                color: token.colorTextSecondary,
                fontSize: 14,
              }}
            >
              {description}
            </p>
          ) : null}
        </div>
        {actions ? <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>{actions}</div> : null}
      </div>
      {children}
    </div>
  );
}

/** Hook helpers for screens that need brand tokens via theme schema */
export function useBrandToken() {
  const { token } = antTheme.useToken();
  return {
    token,
    primary: token.colorBrandPrimary || token.colorInfo,
    secondary: token.colorBrandSecondary || token.colorInfo,
    accent: token.colorPrimary,
    alert: token.colorError,
    background: token.colorBgLayout,
    ink: token.colorText,
    border: token.colorBorder,
    white: token.colorBgContainer,
    muted: token.colorTextSecondary,
    mutedSoft: token.colorTextTertiary,
    primarySoft: token.colorBrandSoft || token.colorFillAlter,
    accentSoft: token.colorAccentSoft || token.colorFillAlter,
    onPrimary: token.colorTextLightSolid,
  };
}
